import React from 'react';
import styled from 'styled-components';
import FlexboxContainerComponent from 'components/UI/FlexboxContainer';
import { Text } from 'styles/themeColors';
import { currencySign } from 'utils/formatters';
import { A } from 'hooks/useHookRouterCompat';
import ConsignmentEntry from 'data/ConsignmentEntry';

const CommissionText = styled.span`
  font-size: 14px;
  width: 234px;
  line-height: 18px;
  color: ${Text.secondary};
`;

const AffiliateLink = styled(A)`
  color: ${Text.secondary};
  &:hover { text-decoration: underline; }
`;

interface Props {
  commissionPercentage: number;
  commissionAmount: number;
  customerAffiliate: ConsignmentEntry['customerAffiliate'];
  country: string | null;
}

const AffiliateCommissionLine: React.FC<Props> = ({
  commissionPercentage,
  commissionAmount,
  customerAffiliate,
  country
}) => {
  const affiliate = customerAffiliate?.customer;

  return (
    <FlexboxContainerComponent>
      <CommissionText>
        {`Commission: ${commissionPercentage}% (${currencySign(country, commissionAmount)}) – Affiliate: `}
        {affiliate?.id
          ? <AffiliateLink href={`/affiliate-members/${affiliate.id}`}>{affiliate.firstName} {affiliate.lastName}</AffiliateLink>
          : affiliate
            ? `${affiliate.firstName} ${affiliate.lastName}`
            : 'N/A'
        }
      </CommissionText>
    </FlexboxContainerComponent>
  );
};

export default AffiliateCommissionLine;
